module.exports = __webpack_public_path__ + "static/media/BB_megafon.61bb384c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BB_megafon.png
// module id = 229
// module chunks = 0